import React, { useState, useEffect } from "react";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2'
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap"
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel';
import '../../components/loader.css';
import { useNavigate } from 'react-router-dom'
import TablePagination from '@mui/material/TablePagination';
import Sub_header from '../Sub_header'

const Vas_prices = () => {
    let navigate = useNavigate();
    const [state, setState] = useState({ isLoading: true, user_info: {} });
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000
    })

    useEffect(() => {
        getUsersInfo();
      
    }, [])

    const getUsersInfo = () => {

        
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/vas_prices_detail`;
        let sendData = {};
        axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
           setState({ ...state, user_info: res.data.output[0], isLoading: false })
           }).catch((e) => {
        });
    }

    const updatevasprices = () => {

        
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/vas_prices_update`;
        let sendData = state.user_info;
        axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
        if (res.data.status == 200) {
                Toast.fire({
                    background: "#10b93b",
                    type: 'success',
                    title: "Updated Successfully !",
                    color: "white"
                });
            }
    }).catch((e) => {
           
    });
    }

    const handlenotificationprices = (e) => {
       
        let userTemp = { ...state.user_info };
        // console.log("userTemp ", userTemp[e.target.name]);
        userTemp[e.target.name] = e.target.value;
        setState({ ...state, user_info: userTemp });

    }


    
  return (
    <div>
        <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
       
       <section class="home-section">
              
       <Sub_header/>
      
      

<div class="row py-4">
    <div class="col-12 col-md">
      
        <h2 class="h4">VAS Prices</h2>
    </div>
    <div class="col-12 col-md-5">
        
    </div>
   
</div>


<div class="card card-body border-0 shadow table-wrapper table-responsive">
<div class="row ">
                                                        <div class="col-12 col-md">
                                                            <div class="d-flex justify-content-between">
                                                                <div class="">
                                                                    <label for="email" class="form-label">Delivery Updates:</label>
                                                                </div>
                                                              
                                                            </div>
                                                            <div class="input-group">
                                                                <span class="input-group-text">INR</span>
                                                                <input type="number" class="form-control" placeholder="Enter delivery updates price" name="delivery_update_price"  onChange={(e)=>handlenotificationprices(e)} value={state.user_info.delivery_update_price?state.user_info.delivery_update_price:""}/>
                                                              </div>
                                                        </div>

                                                        <div class="col-12 col-md">
                                                            <div class="d-flex justify-content-between">
                                                                <div class="">
                                                                    <label for="email" class="form-label">COD Verification:</label>
                                                                </div>

                                                            </div>
                                                            <div class="input-group">
                                                                <span class="input-group-text">INR</span>
                                                                <input type="number" class="form-control" placeholder="Enter cod verification price " name="cod_verification_price" onChange={(e) => handlenotificationprices(e)} value={state.user_info.cod_verification_price ?? ""} />
                                                            </div>
                                                        </div>
                                                    </div>



                                                    <div class="mt-3">
                                                        <button class="btn btn-gray-800 mt-2 animate-up-2" type="button" 
                                                        onClick={() => updatevasprices()}
                                                        >Save</button>
                                                    </div>
           
        </div> 
        
        
       
                

</section>




    </div>
  )
}

export default Vas_prices
